<div class="affcode-selector-container">
  <div class="row hidden-xs">
    <div class="col-sm-5">
      <h4>
        {{ 'affiliation.affcode-selector.avail-affcodes' | translate | titlecase }}
      </h4>
    </div>

    <div class="col-sm-offset-2 col-sm-5">
      <h4>
        {{ 'affiliation.affcode-selector.selected-affcodes' | translate | titlecase }}
      </h4>
    </div>
  </div>

  <div class="mct-flex-gt-xs mct-row-gt-xs mct-flex-lt-sm mct-col-lt-sm">
    <div class="mct-basis-40">
      <h4 class="hidden-sm hidden-md hidden-lg">
        {{ 'affiliation.affcode-selector.avail-affcodes' | translate | titlecase }}
      </h4>
      <div class="wl-aff-code-selector-box">
        <ul class="list-unstyled">
          <li *ngFor="let affCodeType of affCodeTypes" [hidden]="affCodeType.AffCodes.length <= 0">
            <div
              class="wl-aff-code-selector-type"
              [ngClass]="{ 'wl-aff-code-type-open': affCodeType.Selected }"
              (click)="affCodeType.Selected = !affCodeType.Selected"
            >
              <span class="pi pi-chevron-right"></span>
              <span *ngIf="affCodeType.AffCodeType != ''">{{ affCodeType.AffCodeType }}</span>
              <span *ngIf="affCodeType.AffCodeType == ''">{{ 'common.none' | translate | titlecase }}</span>
            </div>
            <ul class="list-unstyled" [hidden]="!affCodeType.Selected">
              <li
                class="wl-aff-code-selector-code"
                [class.bg-primary]="affCode.Selected"
                *ngFor="let affCode of affCodeType.AffCodes"
                (click)="toggleAvailAffCodeSelected(affCode)"
              >
                {{ affCode.AffCode }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class="mct-basis-20">
      <p class="hidden-xs text-center">
        <button pButton type="button" icon="pi pi-chevron-right" class="btn btn-default" (click)="addAffCodes()"></button>
      </p>
      <p class="hidden-xs text-center">
        <button pButton type="button" icon="pi pi-chevron-left" class="btn btn-default" (click)="removeAffCodes()"></button>
      </p>

      <p class="wl-aff-code-selector-button-mobile hidden-sm hidden-md hidden-lg">
        <button pButton type="button" icon="pi pi-chevron-down" class="btn btn-default" (click)="addAffCodes()"></button>

        <button pButton type="button" icon="pi pi-chevron-up" class="btn btn-default" (click)="removeAffCodes()"></button>
      </p>
    </div>

    <div class="mct-basis-40">
      <h4 class="hidden-sm hidden-md hidden-lg">
        {{ 'affiliation.affcode-selector.selected-affcodes' | translate | titlecase }}
      </h4>
      <div *ngIf="showAllOfOneOfOptions">
        {{ allOfOneOfPromptLabel || ('affiliation.affcode-selector.all-of-one-of-default-prompt' | translate) }}
        <label
          ><input
            type="radio"
            [name]="'all-of-' + UniqueId"
            class="wl-affcode-allof-radio"
            [(ngModel)]="_allOfSelected"
            value="1"
            (click)="handleAllOfClick(true)"
          />
          {{ 'affiliation.affcode-selector.all-of-label' | translate }}</label
        >
        <label
          ><input
            type="radio"
            [name]="'all-of-' + UniqueId"
            class="wl-affcode-oneof-radio"
            [(ngModel)]="_allOfSelected"
            value="0"
            (click)="handleAllOfClick(false)"
          />
          {{ 'affiliation.affcode-selector.one-of-label' | translate }}</label
        >
        {{ 'affiliation.affcode-selector.prompt-ending-of-label' | translate }}
      </div>
      <div class="wl-aff-code-selector-box">
        <ul class="list-unstyled">
          <li
            *ngFor="let affCode of selectedAffCodes"
            class="wl-aff-code-selector-code"
            [class.bg-primary]="affCode.Selected"
            [class.disabled]="isReserved(affCode)"
            [title]="isReserved(affCode) ? 'This affiliation code is reserved.' : ''"
            (click)="toggleSelectedAffCodeSelected(affCode)"
          >
            {{ affCode.AffCode }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
